<template>
  <el-row id="signCla">
    <div id="singCla_section">
      <el-row class="content">
        <el-col>
          <p class="contentTitle" v-if="showInput === 'employee'">
            {{ $t('signPage.claContentTitle') }}
          </p>
          <p class="contentTitle" v-else>{{ $t('signPage.claTitle') }}</p>
          <el-row class="marginTop3rem form" v-if="showInput === 'employee'">
            <h3 style="text-align: center">
              {{ $t('signPage.claContentSTitle') }}
            </h3>
            {{ $t('signPage.claContent1')
            }}<span class="title">{{ companyName }}</span
            >{{ $t('signPage.claContent2', { name: communityName })
            }}<span class="title">{{ myForm.email }}</span>
            {{ $t('signPage.claContent3', { name: communityName })
            }}<span class="title">{{ companyName }}</span>
            {{ $t('signPage.claS') }}
            <br>
            <h3 style="display: inline-block">{{ $t('signPage.claZ') }}</h3>
            {{ $t('signPage.claContentT') }}</el-row
          >
          <el-row class="marginTop3rem" id="claBox" v-else>
            <div id="pdfContainer" style="width: 100%; height: 900px"></div>
          </el-row>
          <el-row class="marginTop3rem form">
            <el-col>
              <el-form
                v-if="this.IS_MOBILE"
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-position="left"
                label-width="25%"
                class="demo-ruleForm"
              >
                <el-form-item
                  v-for="(item, index) in fields"
                  label-width="0"
                  :key="index"
                  :required="item.required"
                  :prop="item.id"
                >
                  <div>
                    <span v-if="item.required" class="requiredIcon">*</span
                    >{{ item.title }}
                  </div>
                  <el-input
                    v-if="item.type === 'date'"
                    readonly=""
                    v-model="ruleForm[item.id]"
                    size="small"
                    @input="setMyForm(item.type, ruleForm[item.id])"
                  ></el-input>
                  <el-input
                    v-else
                    v-model="ruleForm[item.id]"
                    :placeholder="
                      item.type === 'email' && showInput === 'employee'
                        ? $t('signPage.claHolder')
                        : $t('signPage.holder', { title: item.title })
                    "
                    size="small"
                    @input="setMyForm(item.type, ruleForm[item.id])"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label="$t('signPage.corp')"
                  v-if="showInput === 'employee'"
                  required
                >
                  <el-select
                    v-model="orgValue"
                    :placeholder="$t('org.config_cla_select_org_placeholder')"
                    size="small"
                    style="width: 100%"
                    clearable
                    filterable
                    @visible-change="orgVisibleChange"
                    :disabled="getOrg"
                  >
                    <el-option
                      v-for="item in signingData"
                      :key="item.corp_signing_id"
                      :label="item.corp_name"
                      :value="item.corp_signing_id"
                      @click.native="getCompany(item.corp_name)"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="rules.code" label-width="0" prop="code">
                  <div>
                    <span class="requiredIcon">*</span
                    >{{ $t('signPage.verifyCode') }}
                  </div>
                  <el-input
                    v-model="ruleForm.code"
                    :placeholder="$t('signPage.verifyCodeHolder')"
                    size="small"
                  >
                  </el-input>
                </el-form-item>
                <button
                  class="margin-top-1rem mobileBt"
                  type="button"
                  :disabled="sendBtDisable"
                  @click="sendCode()"
                >
                  {{ sendBtTextFromLang }}
                </button>
                <div class="borderClass fontSize12">
                  <span class="requiredIcon">*</span
                  >{{ $t('signPage.requireText') }}
                </div>
                <div class="margin-top-1rem fontSize12">
                  <el-checkbox v-model="isRead"
                    ><span
                      >{{ $t('signPage.checkBoxText1')
                      }}<a :href="privacyUrl" target="_blank" class="privacy">{{
                      $t('signPage.privacy')
                      }}</a
                      >{{ $t('signPage.checkBoxText2')
                      }}<span> {{ $t('signPage.claSignPlatform') }}</span
                      >{{ $t('signPage.checkBoxText3') }}</span
                    >
                  </el-checkbox>
                </div>
                <el-form-item label-width="0" class="margin-top-1rem signBtBox">
                  <button
                    class="mobileBt"
                    type="button"
                    @click="submitForm('ruleForm')"
                  >
                    {{ $t('signPage.sign') }}
                  </button>
                </el-form-item>
              </el-form>
              <el-form
                v-else
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-position="left"
                label-width="25%"
                class="demo-ruleForm"
              >
                <el-form-item
                  v-for="(item, index) in fields"
                  :label="item.title"
                  :required="item.required"
                  :prop="item.id"
                  :key="index"
                >
                  <el-input
                    v-if="item.type === 'date'"
                    readonly=""
                    v-model="ruleForm[item.id]"
                    size="small"
                    @input="setMyForm(item.type, ruleForm[item.id])"
                  ></el-input>
                  <el-input
                    v-else
                    v-model="ruleForm[item.id]"
                    :placeholder="
                      item.type === 'email' && showInput === 'employee'
                        ? $t('signPage.claHolder')
                        : $t('signPage.holder', { title: item.title })
                    "
                    size="small"
                    @input="setMyForm(item.type, ruleForm[item.id])"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label="$t('signPage.corp')"
                  v-if="showInput === 'employee'"
                  required
                >
                  <el-select
                    v-model="orgValue"
                    :placeholder="$t('org.config_cla_select_org_placeholder')"
                    size="small"
                    style="width: 100%"
                    clearable
                    filterable
                    @visible-change="orgVisibleChange"
                    :disabled="getOrg"
                  >
                    <el-option
                      v-for="item in signingData"
                      :key="item.corp_signing_id"
                      :label="item.corp_name"
                      :value="item.corp_signing_id"
                      @click.native="getCompany(item.corp_name)"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="sendCodeClass"
                  v-if="rules.code"
                  :label="$t('signPage.verifyCode')"
                  prop="code"
                >
                  <el-input
                    v-model="ruleForm.code"
                    :placeholder="$t('signPage.verifyCodeHolder')"
                    size="small"
                  >
                    <el-tooltip
                      slot="append"
                      :content="$t('signPage.sendCodeTip')"
                      placement="top"
                      effect="light"
                      popper-class="my_tooltip"
                    >
                      <el-button :disabled="sendBtDisable" @click="sendCode()"
                        >{{ sendBtTextFromLang }}
                      </el-button>
                    </el-tooltip>
                  </el-input>
                </el-form-item>
                <div class="borderClass fontSize12">
                  <span class="requiredIcon">*</span
                  >{{ $t('signPage.requireText') }}
                </div>
                <div v-if="showInput === 'corporation'">
                  <div class="borderClass fontSize12">
                    {{ $t('signPage.tip') }}
                  </div>
                  <div class="borderClass fontSize12">
                    {{ $t('signPage.tip1') }}
                  </div>
                  <div class="borderClass fontSize12">
                    {{ $t('signPage.tip2') }}
                  </div>
                  <div class="borderClass fontSize12">
                    {{ `${$t('signPage.tip3_1')}${emailAddr}${$t('signPage.tip3_2')}` }}
                  </div>
                </div>
                <div class="margin-top-1rem fontSize12">
                  <el-checkbox v-model="isRead"
                    ><span
                      >{{ $t('signPage.checkBoxText1')
                      }}<a :href="privacyUrl" target="_blank" class="privacy">{{
                        $t('signPage.privacy')
                      }}</a
                      >{{ $t('signPage.checkBoxText2')
                      }}<span> {{ $t('signPage.claSignPlatform') }}</span
                      >{{ $t('signPage.checkBoxText3') }}</span
                    >
                  </el-checkbox>
                </div>
                <el-form-item
                  label-width="0"
                  class="margin-top-1rem padding-top-bottom-1rem signBtBox"
                >
                  <HttpButton
                    :text="$t(`signPage.${signText}`)"
                    :buttonDisable="signButtonDisable"
                    :width="signButtonWidth"
                    :height="signButtonHeight"
                    :borderRaduis="signButtonBorderRadius"
                    @httpSubmit="submitForm('ruleForm')"
                  >
                  </HttpButton>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <ReLoginDialog
      :dialogVisible="reLoginDialogVisible"
      :message="reLoginMsg"
    ></ReLoginDialog>
    <ReTryDialog
      :dialogVisible="reTryDialogVisible"
      :message="reLoginMsg"
    ></ReTryDialog>
    <SignSuccessDialog
      :dialogVisible="signSuccessDialogVisible"
      :message="reLoginMsg"
    ></SignSuccessDialog>
    <SignReLoginDialog
      :dialogVisible="signReLoginDialogVisible"
      :message="reLoginMsg"
    ></SignReLoginDialog>
  </el-row>
</template>

<script>
import { mapActions } from 'vuex';
import PDFObject from 'pdfobject';

import * as util from '../util/util';
import * as url from '../util/api';
import axios from '../util/_axios';
import ReLoginDialog from '../components/ReLoginDialog';
import ReTryDialog from '../components/ReTryDialog';
import SignSuccessDialog from '../components/SignSuccessDialog';
import SignReLoginDialog from '../components/SignReLoginDialog';
import HttpButton from '../components/HttpButton';
import cla from '../lang/global';

export default {
  name: 'SignCla',
  computed: {
    loginType() {
      return this.$store.state.loginType;
    },
    org() {
      let org = this.$store.state.repoInfo.org_id;
      if (org.length > 1) {
        return org.charAt(0).toUpperCase() + org.substring(1);
      } else {
        return org.charAt(0).toUpperCase();
      }
    },
    reLoginDialogVisible() {
      return this.$store.state.dialogVisible;
    },
    reLoginMsg() {
      return this.$store.state.dialogMessage;
    },
    reTryDialogVisible() {
      return this.$store.state.reTryDialogVisible;
    },
    signSuccessDialogVisible() {
      return this.$store.state.signSuccessDialogVisible;
    },
    signReLoginDialogVisible() {
      return this.$store.state.signReLoginDialogVisible;
    },
    sendBtTextFromLang: {
      get: function () {
        return this.sendBtText;
      },
      set: function (value) {
        this.sendBtText = value;
      },
    },
    privacyUrl() {
      if (this.communityName === 'openFuyao') {
        // FIXME: redirect to public website after released
        return 'https://gitee.com/openfuyao/cla/raw/master/pdf/openFuyao隐私政策.pdf'
      }
      const { hostname: subdomain, port } = globalThis.location;
      const domain = subdomain.split('.').slice(-2).join('.');
      return `https://${domain}${port && ':' + port}/zh/privacy`;
    },
    emailAddr() {
      const { hostname: subdomain } = globalThis.location;
      const domain = subdomain.split('.').slice(-2).join('.');
      return `team@${domain}`;
    }
  },
  watch: {
    '$i18n.locale'() {
      if (this.$route.path !== '/sign-cla') {
        return;
      }
      this.cla_lang = '';
      this.lang = localStorage.getItem('lang');
      this.signPageData.forEach((item, index) => {
        if (item.language === this.lang) {
          this.cla_lang = item.language;
          this.value = index;
          this.cla_hash = item.cla_id;
          this.cla_id = item.cla_id;
          sessionStorage.setItem('cla_id', item.cla_id);
          this.fields = this.signPageData[this.value].fields;
          this.setClaPdf();
          if (Object.keys(this.rules).length === 0) {
            this.setFieldsData();
          }
        }
      });
      this.setSendBtText();
      this.$refs['ruleForm'] &&
        this.$refs['ruleForm'].fields.forEach(item => {
          if (item.validateState === 'error') {
            this.$refs['ruleForm'].validateField(item.labelFor);
          }
        });
    },
  },
  inject: ['setClientHeight'],
  components: {
    ReLoginDialog,
    ReTryDialog,
    SignSuccessDialog,
    SignReLoginDialog,
    HttpButton,
  },
  data() {
    return {
      sendBtDisable: false,
      signText: 'sign',
      signButtonDisable: false,
      signButtonWidth: '15rem',
      signButtonHeight: '3rem',
      signButtonBorderRadius: '1.5rem',
      corporation: 'corporation',
      individual: 'individual',
      employee: 'employee',
      claText: '',
      numPages: null,
      lang: '',
      cla_hash: '',
      second: '',
      sendBtText: this.$t('signPage.sendCode'),
      domain: this.$store.state.domain,
      tipsTitle: '',
      tipsMessage: this.$t('tips.individual_sign'),
      tipsDialogVisible: false,
      signPageData: '',
      link_id: this.$store.state.linkId,
      claOrgIdArr: [],
      fields: [],
      claIdArr: [],
      isVerify: false,
      verifyCode: '',
      dialogVisible: false,
      repositoryOptions: [],
      role: '0',
      ruleForm: {},
      myForm: {},
      rules: {},
      isRead: false,
      value: '',
      cla_lang: '',
      signingData: [],
      orgValue: '',
      cla_id: '',
      showInput: sessionStorage.getItem('loginType'),
      getOrg: true,
      companyName: '',
      communityName:''
    };
  },
  methods: {
    ...mapActions(['setTokenAct', 'setRepoInfoAct']),
    getCompany(val) {
      this.companyName = val;
    },
    setSendBtText() {
      if (
        this.sendBtTextFromLang === 'send code' ||
        this.sendBtTextFromLang === '发送验证码'
      ) {
        this.sendBtTextFromLang = this.$t('signPage.sendCode');
      } else {
        this.sendBtTextFromLang = this.$t('signPage.reSendCode', {
          second: this.second,
        });
      }
    },
    previewPrivacy() {
      util.toPrivacy(this);
    },
    async requireVerifyTel(rule, value, callback) {
      if (value) {
        let reg = /^1[3456789]\d{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error(this.$t('tips.invalid_telephone_num')));
        }
      } else {
        callback(new Error(this.$t('tips.not_fill_telephone_num')));
      }
    },
    async verifyTel(rule, value, callback) {
      if (value) {
        let reg = /^1[3456789]\d{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error(this.$t('tips.invalid_telephone_num')));
        }
      }
    },
    async verifyAddr(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('tips.not_fill_address')));
      } else {
        callback();
      }
    },
    async verifyFax(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('tips.not_fill_fax')));
      } else {
        callback();
      }
    },
    async verifyFormEmail(rule, value, callback) {
      let email = '';
      if (value) {
        email = value.trim();
      }
      if (cla.EMAIL_REG.test(email)) {
        callback();
        this.getOrg = false;
      } else {
        callback(new Error(this.$t('tips.invalid_email')));
        this.getOrg = true;
      }
    },
    async verifyName(rule, value, callback) {
      if (value) {
        callback();
      } else {
        callback(new Error(this.$t('tips.fill_name')));
      }
    },
    async verifyCorpName(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('tips.fill_corp_name')));
      } else {
        callback();
      }
    },
    async verifyTitle(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('tips.fill_representative_title')));
      } else {
        callback();
      }
    },
    async verifyAuthorized(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('tips.fill_representative_name')));
      } else {
        callback();
      }
    },
    async verifyDate(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('tips.fill_date')));
      } else {
        callback();
      }
    },
    async verifyCodeCheck(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('tips.fill_verification_code')));
      } else {
        callback();
      }
    },
    setMyForm(type, value) {
      this.companyName = '';
      this.myForm[type] = value;
      if (!this.myForm.email) {
        this.getOrg = true;
      }
    },
    sendCode() {
      let email = this.myForm.email;
      let _url = '';
      if (sessionStorage.getItem('loginType') === 'corporation') {
        _url = `${url.sendCorporationCode}/${this.link_id}/code`;
      } else if (sessionStorage.getItem('loginType') === 'individual') {
        _url = `${url.sendVerifyCode}/${this.link_id}/code`;
      } else if (sessionStorage.getItem('loginType') === 'employee') {
        _url = `${url.sendEmployeeCode}/${this.link_id}/${this.orgValue}/code`;
      }
      if (email && EMAIL_REG.test(email)) {
        this.sendBtDisable = true;
        axios({
          url: _url,
          method: 'post',
          data: { email: this.myForm.email },
        })
          .then(res => {
            this.$message.closeAll();
            this.$message.success({
              message: this.$t('tips.sending_email'),
              duration: 8000,
            });
            this.second = 60;
            let codeInterval = setInterval(() => {
              if (this.second !== 0) {
                this.second--;
                this.sendBtTextFromLang = this.$t('signPage.reSendCode', {
                  second: this.second,
                });
              } else {
                this.sendBtTextFromLang = this.$t('signPage.sendCode');
                this.sendBtDisable = false;
                clearInterval(codeInterval);
              }
            }, 1000);
          })
          .catch(err => {
            util.catchErr(err, 'setSignReLogin', this);
          });
      } else {
        this.$message.closeAll();
        if (EMAIL_REG.test(email) && !this.orgValue) {
          this.$message.error(this.$t('tips.not_fill_org'));
        } else {
          this.$message.error(this.$t('tips.not_fill_email'));
        }
      }
    },
    getNowDate() {
      let date = new Date();
      let year, month, day;
      year = date.getFullYear();
      date.getMonth() < 9
        ? (month = `0${date.getMonth() + 1}`)
        : (month = date.getMonth() + 1);
      date.getDate() < 10
        ? (day = `0${date.getDate()}`)
        : (day = date.getDate());
      for (let item of this.fields) {
        if (item.type === 'date') {
          this.myForm.date = year + '-' + month + '-' + day;
          Object.assign(this.ruleForm, {
            [item.id]: year + '-' + month + '-' + day,
          });
          break;
        }
      }
    },
    setData(res, resolve) {
      if (res && res.data.data) {
        if (res.data.data && res.data.data.length) {
          this.signPageData = res.data.data;
          if (localStorage.getItem('lang') !== undefined) {
            this.lang = localStorage.getItem('lang');
          }
          let langOptions = [];
          let langLabel = '';
          this.signPageData.forEach((item, index) => {
            langLabel = util.upperFirstCase(item.language);
            langOptions.push({ value: index, label: langLabel });
            if (item.language === this.lang) {
              this.cla_lang = item.language;
              sessionStorage.setItem('cla_id', item.cla_id);
              this.value = index;
              this.cla_hash = item.cla_hash;
            }
          });
          this.$emit('getLangOptions', langOptions);
          if (!this.cla_lang) {
            this.lang = this.signPageData[0].language;
            this.cla_lang = this.signPageData[0].language;
            this.value = 0;
            this.cla_hash = this.signPageData[0].cla_hash;
            localStorage.setItem('lang', util.upperFirstCase(this.lang));
          }
          this.setClaPdf();
          this.setFields(this.value);
          this.setFieldsData();
          resolve('complete');
          this.$emit('initHeader', util.upperFirstCase(this.lang));
        } else {
          let message = '';
          if (this.$store.state.loginType === this.corporation) {
            message = this.$t('tips.no_cla_binding_corp');
          } else if (this.$store.state.loginType === this.employee) {
            message = this.$t('tips.no_cla_binding_emp');
          }
          if (this.$store.state.loginType === this.individual) {
            message = this.$t('tips.no_cla_binding_individual');
          }
          this.$store.commit('setSignReLogin', {
            dialogVisible: true,
            dialogMessage: message,
          });
        }
      }
    },
    getSignPage(resolve) {
      let applyTo = '';
      this.loginType === this.corporation
        ? (applyTo = this.loginType)
        : (applyTo = this.individual);
      if (!this.$store.state.linkId) {
        this.$store.commit('errorCodeSet', {
          dialogVisible: true,
          dialogMessage: this.$t('tips.page_error'),
        });
        return;
      }
      axios({
        url: `${url.getSignPage}/${this.$store.state.linkId}/${applyTo}`,
      })
        .then(res => {
          this.setData(res, resolve);
        })
        .catch(err => {
          util.catchErr(err, 'setSignReLogin', this);
        });
    },
    async setClaPdf() {
      const claId = sessionStorage.getItem('cla_id');
      const pdf = new Blob([
        await (await fetch(`${process.env.BASE_URL}api/${url.getCLAPdf}/${this.link_id}/${claId}`)).arrayBuffer()
      ], { type: 'application/pdf' });
      URL.revokeObjectURL(this.claPdfUrl);
      this.claPdfUrl = URL.createObjectURL(pdf);
      const iframe = PDFObject.embed(this.claPdfUrl, '#pdfContainer', {
        pdfOpenParams: {
          view: 'FitH',
          navpanes: 0,
          zoom: 'page-width',
        },
        PDFJS_URL: `${process.env.BASE_URL}static/pdf_source/web/viewer.html`,
      });
      iframe.classList.add('iframeClass');
    },
    setFields(key) {
      for (let i = 0; i < this.signPageData[key].fields.length; i++) {
        for (let j = i + 1; j < this.signPageData[key].fields.length; j++) {
          if (
            Number(this.signPageData[key].fields[i].id) >
            Number(this.signPageData[key].fields[j].id)
          ) {
            let field = this.signPageData[key].fields[i];
            this.signPageData[key].fields[i] = this.signPageData[key].fields[j];
            this.signPageData[key].fields[j] = field;
          }
        }
      }
      this.fields = this.signPageData[key].fields;
    },
    setFieldsData() {
      let form = {};
      let rules = {};
      this.fields.forEach(item => {
        Object.assign(form, { [item.id]: '' });
        if (item.type === 'name') {
          Object.assign(this.myForm, { name: '' });
          item.required &&
            Object.assign(rules, {
              [item.id]: [
                {
                  required: item.required,
                  validator: this.verifyName,
                  trigger: ['blur', 'change'],
                },
              ],
            });
        } else if (item.type === 'corporationName') {
          Object.assign(this.myForm, { corporationName: '' });
          item.required &&
            Object.assign(rules, {
              [item.id]: [
                {
                  required: item.required,
                  validator: this.verifyCorpName,
                  trigger: ['blur', 'change'],
                },
              ],
            });
        } else if (item.type === 'title') {
          Object.assign(this.myForm, { title: '' });
          item.required &&
            Object.assign(rules, {
              [item.id]: [
                {
                  required: item.required,
                  validator: this.verifyTitle,
                  trigger: ['blur', 'change'],
                },
              ],
            });
        } else if (item.type === 'authorized') {
          Object.assign(this.myForm, { authorized: '' });
          item.required &&
            Object.assign(rules, {
              [item.id]: [
                {
                  required: item.required,
                  validator: this.verifyAuthorized,
                  trigger: ['blur', 'change'],
                },
              ],
            });
        } else if (item.type === 'date') {
          Object.assign(this.myForm, { date: '' });
          item.required &&
            Object.assign(rules, {
              [item.id]: [
                {
                  required: item.required,
                  validator: this.verifyDate,
                  trigger: ['blur', 'change'],
                },
              ],
            });
        } else if (item.type === 'email') {
          Object.assign(this.myForm, { email: '' });
          item.required &&
            Object.assign(rules, {
              [item.id]: [
                {
                  required: item.required,
                  validator: this.verifyFormEmail,
                  trigger: ['blur', 'change'],
                },
              ],
            });
        } else if (item.type === 'telephone') {
          Object.assign(this.myForm, { telephone: '' });
          if (item.required) {
            Object.assign(rules, {
              [item.id]: [
                {
                  required: item.required,
                  validator: this.requireVerifyTel,
                  trigger: ['blur', 'change'],
                },
              ],
            });
          } else {
            Object.assign(rules, {
              [item.id]: [
                {
                  validator: this.verifyTel,
                  trigger: ['blur', 'change'],
                },
              ],
            });
          }
        } else if (item.type === 'address') {
          Object.assign(this.myForm, { address: '' });
          item.required &&
            Object.assign(rules, {
              [item.id]: [
                {
                  required: item.required,
                  validator: this.verifyAddr,
                  trigger: ['blur', 'change'],
                },
              ],
            });
        } else if (item.type === 'fax') {
          Object.assign(this.myForm, { fax: '' });
          item.required &&
            Object.assign(rules, {
              [item.id]: [
                {
                  required: item.required,
                  validator: this.verifyFax,
                  trigger: ['blur', 'change'],
                },
              ],
            });
        }
      });
      Object.assign(form, { code: '' });
      Object.assign(this.myForm, { code: '' });
      Object.assign(rules, {
        code: [
          {
            required: true,
            validator: this.verifyCodeCheck,
            trigger: ['blur', 'change'],
          },
        ],
      });
      this.ruleForm = form;
      this.rules = rules;
    },
    //签署
    signCla() {
      let info = {};
      let myUrl = '';
      let obj = {};
      for (let key in this.ruleForm) {
        if (this.ruleForm[key] !== '') {
          Object.assign(info, { [key]: this.ruleForm[key] + '' });
        }
      }
      if (this.$store.state.loginType === this.corporation) {
        myUrl = `${url.corporation_signing}/${this.link_id}`;
        obj = {
          corporation_name: this.myForm.corporationName,
          admin_name: this.myForm.authorized,
          admin_email: this.myForm.email,
          enabled: true,
          info: info,
          verification_code: this.ruleForm.code,
          corp_signing_id: this.orgValue,
          cla_id: sessionStorage.getItem('cla_id'),
          cla_language: this.cla_lang,
          privacy_checked: this.isRead,
        };
      } else {
        if (this.$store.state.loginType === this.employee) {
          obj = {
            name: this.myForm.name,
            email: this.myForm.email,
            verification_code: this.ruleForm.code,
            info: info,
            cla_id: sessionStorage.getItem('cla_id'),
            cla_language: this.cla_lang,
            corp_signing_id: this.orgValue,
            privacy_checked: this.isRead,
          };
        } else {
          obj = {
            name: this.myForm.name,
            email: this.myForm.email,
            verification_code: this.ruleForm.code,
            info: info,
            cla_id: sessionStorage.getItem('cla_id'),
            cla_language: this.cla_lang,
            privacy_checked: this.isRead,
          };
        }

        if (this.$store.state.loginType === this.individual) {
          myUrl = `${url.individual_signing}/${this.link_id}`;
        } else if (this.$store.state.loginType === this.employee) {
          myUrl = `${url.employee_signing}/${this.link_id}`;
        }
      }
      this.sign(myUrl, obj);
    },
    sign(myUrl, obj) {
      if (!myUrl) {
        return;
      }
      this.signText = 'signing';
      this.signButtonDisable = true;
      axios({
        url: myUrl,
        method: 'post',
        data: obj,
      })
        .then(res => {
          this.signText = 'sign';
          this.signButtonDisable = false;
          if (this.$store.state.loginType === this.corporation) {
            this.tipsMessage = this.$t('tips.corp_sign');
          } else if (this.$store.state.loginType === this.employee) {
            this.tipsMessage = this.$t('tips.emp_sign');
          } else if (this.$store.state.loginType === this.individual) {
            this.tipsMessage = this.$t('tips.individual_sign');
          }
          this.$store.commit('setSignSuccess', {
            dialogVisible: true,
            dialogMessage: this.tipsMessage,
          });
        })
        .catch(err => {
          this.signText = 'sign';
          this.signButtonDisable = false;
          util.catchErr(err, 'setSignReLogin', this);
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.isRead) {
            this.signCla();
          } else {
            this.$message.closeAll();
            this.$message.error(this.$t('tips.review_privacy'));
          }
        } else {
          return false;
        }
      });
    },
    //拉取公司列表
    orgVisibleChange(visible) {
      if (visible) {
        this.getOrgsInfo();
      }
    },
    getOrgsInfo() {
      axios({
        url: `${url.getCorporationSigning}/${this.link_id}/corps/${this.myForm.email}`,
        method: 'get',
      })
        .then(res => {
          this.signingData = res.data.data;
        })
        .catch(err => {
          switch (err.status) {
            case 401:
              this.$store.commit('setOrgReLogin', {
                dialogVisible: true,
                dialogMessage: this.$t('tips.not_authorize_group'),
              });
              break;
            case 403:
              this.$store.commit('setOrgReLogin', {
                dialogVisible: true,
                dialogMessage: this.$t('tips.invalid_token'),
              });
              break;
            default:
              this.$store.commit('errorCodeSet', {
                dialogVisible: true,
                dialogMessage: this.$t('tips.system_error'),
              });
          }
        });
    },
    //获取社区名字
    getCommunity(){
      axios({
        url: `${url.getCommunity}/${this.link_id}`,
        method: 'get',
      })
        .then(res => {
          this.communityName = res.data.data.org_alias;
        })
       
    }
  },
  activated() {
    if (this.signPageData) {
      this.setClientHeight();
      if (localStorage.getItem('lang') !== undefined) {
        this.lang = localStorage.getItem('lang');
      }
      let langOptions = [];
      let langLabel = '';
      this.cla_lang = '';
      this.signPageData.forEach((item, index) => {
        langLabel = util.upperFirstCase(item.language);
        langOptions.push({ value: index, label: langLabel });
        if (item.language === this.lang) {
          this.cla_lang = item.language;
          this.value = index;
          this.cla_hash = item.cla_hash;
          this.setClaPdf();
          this.setFields(this.value);
        }
      });
      this.$emit('getLangOptions', langOptions);
      if (!this.cla_lang) {
        this.lang = this.signPageData[0].language;
        this.value = 0;
        this.cla_hash = this.signPageData[0].cla_hash;
        this.setClaPdf();
        this.setFields(this.value);
        localStorage.setItem('lang', util.upperFirstCase(this.lang));
      }
      this.$emit('initHeader', util.upperFirstCase(this.lang));
      this.setSendBtText();
    }
  },
  created() {
    new Promise((resolve, reject) => {
      this.getSignPage(resolve);
    }).then(res => {
      this.getNowDate();
    });
  },
  mounted() {
    this.setClientHeight();
    this. getCommunity()
  },
};
</script>

<style lang="less">
@import '../assets/font/css/Roboto-Bold.css';
@import '../assets/font/css/Roboto-Black.css';
@import '../assets/font/css/Roboto-Light.css';

@media screen and (min-width: 1200px) {
  #singCla_section {
    width: 1200px;
    margin: auto;
  }
}

.signBtBox {
  display: flex;
  justify-content: center;
  width: 100%;

  .el-form-item__content {
    width: 100%;
    text-align: center;
  }
}

.dialogBt {
  margin-top: 3rem;
  width: 8rem;
  height: 3rem;
  background: linear-gradient(to right, #97db30, #319e55);
  border-radius: 1.5rem;
  border: none;
  color: white;
  cursor: pointer;
  outline: none;
}

.privacy {
  cursor: pointer;
  color: #319e55;
}

.codeBox .el-button--medium,
.codeBox .el-button {
  border-radius: 0 4px 4px 0;
}

.codeBox .el-input__inner {
  border-radius: 4px 0 0 4px;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  cursor: pointer;
  border: none;
  background: linear-gradient(to right, #97db30, #319e55);
}

.pointer {
  cursor: pointer;
}

.verifyClass {
  padding: 10rem 0;
}

.borderClass {
  font-size: 1.2rem;
  margin-top: 1rem;
  padding: 1rem 0;
  border-top: 1px dashed #f3f3f3;
}

.form {
  border-radius: 1.25rem;
  box-shadow: 0 0 20px 10px #f3f3f3;
  padding: 2rem;
  margin-bottom: 2rem;
  font-size: 1.2rem;

  .sendCodeClass {
    & .el-input.el-input--small.el-input-group.el-input-group--append {
      position: relative;
    }

    & .el-button.el-button--default {
      position: absolute;
      top: 0;
      left: 0;
      width: 11rem;
      height: 2.5rem;
      border-radius: 1.25rem;
      font-size: 1.2rem;
      color: white;
      margin: 0;
      font-family: Roboto-Light, sans-serif;
    }

    & .el-input-group__append {
      position: absolute;
      right: 0;
      top: 0;
      background: linear-gradient(to right, #97db30, #319e55);
      width: 11rem;
      height: 2.5rem;
      border-radius: 1.25rem;
      padding: 0;
    }
  }

  & .fontSize12 {
    font-size: 1.2rem;
  }

  & .el-input--small .el-input__inner {
    height: 2.5rem;
  }

  & .el-form-item__label {
    font-size: 1.2rem;
  }

  & .el-input__inner {
    background-color: #f3f3f3;
    border-radius: 1.25rem;
    border: 1px solid #f3f3f3;
    font-size: 1.2rem;
  }

  .el-input__inner:focus {
    border-color: #319e55;
  }

  & .el-form-item {
    margin-bottom: 28px;
  }

  & .el-checkbox__label {
    display: inline-grid;
    white-space: pre-line;
    font-size: 1.2rem;
  }

  & .el-checkbox__input.is-checked + .el-checkbox__label {
    display: inline-grid;
    white-space: pre-line;
    color: #606266;
    font-size: 1.2rem;
  }

  & .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #3ea650;
    border-color: #3ea650;
  }

  & .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #3ea650;
  }

  & .el-checkbox__inner {
    border: 1px solid #3ea650;
    width: 20px;
    height: 20px;
  }

  & .el-checkbox__inner:hover {
    border: 1px solid #3ea650;
  }

  & .el-checkbox__inner:focus {
    border: 1px solid #3ea650;
  }

  & .el-checkbox__inner:after {
    height: 10px;
    left: 7px;
    top: 2px;
  }
}

.marginTop3rem {
  margin-top: 3rem;
}

.iframeClass {
  width: 100%;
  height: 900px;
  box-shadow: 0 0 20px 10px #f3f3f3;
  border: none;
  border-radius: 1rem;
}

#claBox {
  margin-bottom: 2rem;
  border-radius: 1.25rem;
  white-space: pre-wrap;
  font-size: 1.2rem;
  /*box-shadow: 0 0 20px 10px #F3F3F3;*/
  /*padding: 2rem;*/
}

.contentTitle {
  font-size: 2rem;
  font-weight: bold;
  margin: 2rem 0;
  text-align: center;
}

.size_s {
  font-size: 0.9rem;
}

#signCla {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .requiredIcon {
    color: #f56c6c;
  }

  & .el-dialog {
    border-radius: 1rem;
  }

  .mobileBt {
    font-family: Roboto-Light, sans-serif;
    width: 100%;
    height: 3rem;
    border-radius: 1.5rem;
    border: none;
    color: white;
    font-size: 1.2rem;
    cursor: pointer;
    background: linear-gradient(to right, #97db30, #319e55);
    margin: 1rem 0;
  }

  .mobileBt:focus {
    outline: none;
  }

  #singCla_section {
    flex-grow: 1;
    font-family: Roboto-Light, sans-serif;
    padding: 0 1rem;

    & .button {
      font-family: Roboto-Light, sans-serif;
      width: 15rem;
      height: 3rem;
      border-radius: 1.5rem;
      border: none;
      color: white;
      font-size: 1.2rem;
      cursor: pointer;
      background: linear-gradient(to right, #97db30, #319e55);
      margin: 1rem 0;
    }

    & .button:focus {
      outline: none;
    }

    & > .content {
      padding: 1rem 0;
      text-align: left;
    }
  }
}
.title {
  border-bottom: 1px solid #000;
  min-width: 50px;
  display: inline-block;
  width: fit-content;
  color: #002fa7;
  text-align: center;
  margin: 0 5px;
}
</style>
